module.exports = __webpack_public_path__ + "img/bt.43aa15d.svg";